var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClockRegular(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_1056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.79688 3.51562C6.79688 3.12598 7.11035 2.8125 7.5 2.8125C7.88965 2.8125 8.20312 3.12598 8.20312 3.51562V7.125L10.7021 8.78906C11.0244 9.00586 11.1123 9.44238 10.8721 9.76465C10.6816 10.0869 10.2451 10.1748 9.92285 9.93457L7.11035 8.05957C6.91406 7.9541 6.79688 7.73438 6.79688 7.47363V3.51562ZM7.5 0C11.6426 0 15 3.35742 15 7.5C15 11.6426 11.6426 15 7.5 15C3.35742 15 0 11.6426 0 7.5C0 3.35742 3.35742 0 7.5 0ZM1.40625 7.5C1.40625 10.8662 4.13379 13.5938 7.5 13.5938C10.8662 13.5938 13.5938 10.8662 13.5938 7.5C13.5938 4.13379 10.8662 1.40625 7.5 1.40625C4.13379 1.40625 1.40625 4.13379 1.40625 7.5Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_1056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockRegular);
export default __webpack_public_path__ + "static/media/clock-regular.6504f8141755b64041215137379aa8d7.svg";
export { ForwardRef as ReactComponent };